import React, { useEffect, useState } from 'react';
import { router, view } from '@forge/bridge';
import DOMPurify from 'dompurify';

import { IncidentPortalBannerDto } from '../../../../../src/common/model';
import {
	getBannersForServicedesk
} from '../../../bridge/incidentBanners';

import { Banner, BannersWrapper } from './IncidentBannersViewStyled';
import { IncidentBannerContext } from './model';


const IncidentBannersView = () => {
	const [banners, setBanners] = useState<IncidentPortalBannerDto[]>([]);

	const fetchBanners = async () => {
		const context = await view.getContext() as IncidentBannerContext;
		const sortedBanners = (await getBannersForServicedesk(context.extension.portal.id))
			.sort((a, b) => b.order - a.order);

		setBanners(sortedBanners);
	};

	useEffect(() => {
		void fetchBanners();
	}, []);

	useEffect(() => {
		const previewLinks = window.document.getElementsByClassName('custom-link');
		Array.from(previewLinks).forEach(linkElement =>
			linkElement.addEventListener('click', e =>  {
					e.preventDefault();
					router.open(linkElement.getAttribute('href') || '');
				}
			));
	});


	return (
		<BannersWrapper>
			{banners.map((banner) =>
				<Banner key={banner.order}>
					<div className='banner' dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(banner.content) }} />
				</Banner>
			)}
		</BannersWrapper>
	);
};

export default IncidentBannersView;
